import { render, staticRenderFns } from "./Huiyu.vue?vue&type=template&id=6cb2ccbc&"
import script from "./Huiyu.vue?vue&type=script&lang=js&"
export * from "./Huiyu.vue?vue&type=script&lang=js&"
import style0 from "./Huiyu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports